import * as tslib_1 from "tslib";
import { JsonObject, JsonProperty } from "json2typescript";
let BaseResponse = class BaseResponse {
    constructor() {
        this.successful = true;
        this.message = '';
    }
};
tslib_1.__decorate([
    JsonProperty('successful')
], BaseResponse.prototype, "successful", void 0);
tslib_1.__decorate([
    JsonProperty('message')
], BaseResponse.prototype, "message", void 0);
BaseResponse = tslib_1.__decorate([
    JsonObject
], BaseResponse);
export { BaseResponse };
